import type { PlayerOrgRatingAllResponsePagedData } from '@on3/api';
import { Filter } from '@on3/ui-lib/components/Filter/Filter';
import { useSite } from '@on3/ui-lib/index';
import { useDynamicRoute } from '@on3/ui-lib/utils/hooks/useDynamicRoute';
import { slugify } from '@on3/ui-lib/utils/slugify';
import { BreadCrumb } from '@public/components/BreadCrumb/BreadCrumb';
import { Rankings } from '@public/components/Db/Profile/Rankings';
import { AdminLink } from '@public/components/User/AdminLink';
import { useAthlete } from '@public/contexts/AthleteProvider';

import { CompactPlayer } from '../Header/CompactHeaderV2/CompactPlayerV2';
import { AboutIndustry } from './AboutIndustry';
import styles from './PlayerAllRankingPage.module.scss';

interface IPlayerAllRankingPageProps {
  allRankingList?: PlayerOrgRatingAllResponsePagedData | null;
}

export const PlayerAllRankingPage = ({
  allRankingList,
}: IPlayerAllRankingPageProps) => {
  const { formatHref, router } = useDynamicRoute();
  const { sportsData } = useSite();

  const { athlete } = useAthlete();
  const { sports } = athlete || {};
  const sportsList =
    sportsData?.filter(
      (sportRecord) =>
        sports?.some((sportBase) => sportRecord.key === sportBase.key),
    ) ?? [];
  const playerSport = (router.query.sport as string) ?? 'football';
  const playerYear = athlete?.classYear ?? new Date().getFullYear();

  return (
    <>
      <AdminLink
        path={`/people/${athlete?.slug}/recruiting/${athlete?.recruitmentKey}/edit/`}
      />
      <div className={styles.block}>
        <header className={styles.header}>
          <h1>Industry Comparison for {athlete?.name}</h1>
          {sportsList.length > 1 && (
            <Filter
              name="sport"
              navigate={(_, v) =>
                formatHref({
                  query: { sport: v },
                })
              }
              options={[
                ...sportsList.map((sport) => ({
                  label: sport.name || '',
                  value: slugify(sport.name) || '',
                })),
              ]}
              value={playerSport}
            />
          )}
        </header>

        <CompactPlayer className={styles.compactPlayer} />
        {/* TODO: update for rivals ? */}
        <BreadCrumb
          className={styles.breadcrumbs}
          crumbs={[
            { title: 'Rivals', href: '/rivals/' },
            {
              title: athlete?.name ?? 'Player Profile',
              href: `/rivals/${athlete.slug}/`,
            },
          ]}
          title="Industry Comparison"
        />

        <div className={styles.industryComparison}>
          <section className={styles.rankings}>
            <Rankings
              allRankingList={allRankingList}
              comparisonLink={`/rivals/rankings/industry-comparison/${playerSport}/${playerYear}/`}
              embedText="Embed"
              rankingYear={playerYear}
            />
          </section>
          {/* TODO: Add Rankings History Graphy */}
          <section>
            <AboutIndustry />
          </section>
        </div>
      </div>
    </>
  );
};
